import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-bt gfu-bt--caption _tc--gray _tac" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_external_link = _resolveComponent("external-link")
  const _component_localize = _resolveComponent("localize")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_localize, {
      resource: _ctx.Resources.Common.CaptchaDisclaimerCaption
    }, {
      default: _withCtx(() => [
        _createVNode(_component_external_link, {
          "format-key": "0",
          href: _ctx.reCaptchaPrivacyPolicyUrl
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.Resources.Common.CaptchaPrivacyPolicyLink), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["href"]),
        _createVNode(_component_external_link, {
          "format-key": "1",
          href: _ctx.reCaptchaTermsUrl
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.Resources.Common.CaptchaTermsOfServiceLink), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["href"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["resource"])
  ]))
}